import React from 'react';

const ReviewsSkeleton: React.FC = () => {
  return (
    <div className="card animate-pulse">
      <div className="card-header">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-neutral-200 rounded-xl"></div>
            <div>
              <div className="w-32 h-5 bg-neutral-200 rounded mb-2"></div>
              <div className="w-48 h-4 bg-neutral-200 rounded"></div>
            </div>
          </div>
          <div className="w-16 h-4 bg-neutral-200 rounded"></div>
        </div>
      </div>
      
      <div className="card-body">
        <div className="space-y-4">
          {[1, 2, 3].map((item) => (
            <div key={item} className="p-4 rounded-xl border-b border-neutral-100 last:border-b-0">
              <div className="flex items-start justify-between mb-3">
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 bg-neutral-200 rounded-full"></div>
                  <div>
                    <div className="w-24 h-4 bg-neutral-200 rounded mb-1"></div>
                    <div className="w-20 h-3 bg-neutral-200 rounded"></div>
                  </div>
                </div>
                
                <div className="flex items-center space-x-1">
                  <div className="w-16 h-4 bg-neutral-200 rounded"></div>
                  <div className="w-8 h-4 bg-neutral-200 rounded"></div>
                </div>
              </div>
              
              <div className="bg-neutral-100 rounded-lg p-3">
                <div className="w-full h-4 bg-neutral-200 rounded"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReviewsSkeleton; 